/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1BrandingVersionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_BRANDING_VERSION_STATE_ENTITY_NAME = 'ixm.userauth.v1.BrandingVersion';
export const ixmUserauthV1BrandingVersionStateEntity = new schema.Entity<IxmUserauthV1BrandingVersionState>(IXM_USERAUTH_V1_BRANDING_VERSION_STATE_ENTITY_NAME, {}, { idAttribute: 'brandingVersionId' });

